import moment from "moment";
import React, { useState, useEffect } from 'react';
import { SecureStorage } from '../Utilities/StorageEncryption';
function checkForIOS(portal) {
    if (navigator.standalone) {
        return false;
    }
    const today = moment().toDate();
    let promptVar = portal == 'mainttech' ? 'installPromptMainttech' : (portal == 'owner' ? 'installPromptOwner' : 'installPromptResident');
    const lastPrompt = moment(SecureStorage.getItem(promptVar));
    const days = moment(today).diff(lastPrompt, "days");
    const ua = window.navigator.userAgent;
    const webkit = !!ua.match(/WebKit/i);
    const isIPad = !!ua.match(/iPad/i);
    const isIPhone = !!ua.match(/iPhone/i)
    const isIOS = isIPad || isIPhone;
    const isSafari = isIOS && webkit && !ua.match(/CriOS/i);

    const prompt = (isNaN(days) || days > 30) && isIOS && isSafari;

    if (prompt && "localStorage" in window) {
        SecureStorage.setItem("installPromptMainttech", today);
        SecureStorage.setItem("installPromptResident", today);
        SecureStorage.setItem("installPromptOwner", today);
    }

    return {isIOS, isSafari, prompt};
}

function useIsIOS(portal) {
    const [isIOSData, setIsIOSData] = useState(null);
    useEffect(() => {
      const data = checkForIOS(portal);
      setIsIOSData(data);
    }, [portal]);
    return isIOSData;
}
export default useIsIOS;